import React, {useState} from 'react';
import Input from "../UI/Input";
import Row from "../UI/Row";
import Button from "../UI/Button";
import ErrorMessage from "../UI/ErrorMessage";
import CheckTermsAndCondition from "../UI/CheckTermsAndCondition";

const Form = ({className = "", onSubmit, errorMessage = null, ...props}) => {

    const formRef = React.useRef();
    const [error, setError] = useState("");
    const [checkedTerms, setCheckedTerms] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");

        let name = formRef.current.name.value;
        let email = formRef.current.email.value;
        let password = formRef.current.password.value;
        let confirmPassword = formRef.current.confirmPassword.value;
        let mobile = formRef.current.mobile.value;
        let fiscal_code = formRef.current.fiscal_code.value;
        let profession = formRef.current.profession.value;

        if (password === confirmPassword) {
            let fields = {
                name,
                email,
                password,
                confirmPassword,
                mobile,
                fiscal_code,
                profession,
            }
            if(checkedTerms) {
                onSubmit && onSubmit(fields);
            } else {
                setError("Accetta i termini e le condizioni");
            }

        } else {
            setError("Le password non coincidono");
        }
    }

    return (
        <form onSubmit={handleSubmit}
              className={className}
              ref={formRef}
              {...props}>
            <div className="mt-4">
                <Row className="gap-4 w-full mb-4 flex-col md:flex-row">
                    <Input label="Nome e Cognome"
                           name="name"
                           required
                           placeholder="nome e cognome"/>
                    <Input label="Email"
                           name="email"
                           type="email"
                           required
                           placeholder="email"/>
                </Row>
                <Row className="gap-4 w-full mb-4 flex-col md:flex-row">
                    <Input label="Contatto telefonico"
                           name="mobile"
                           required
                           placeholder="+39"/>
                    <Input label="Codice Fiscale o PIVA"
                           name="fiscal_code"
                           required
                           placeholder="Codice"/>
                </Row>
                <div>
                    <div className="text-sm text-ea_gray_dark mb-1 text-left">Professione</div>
                    <select name="profession" required className="w-full mb-4 py-2 bg-transparent border"
                            defaultValue={""}>
                        <option className="p-2" disabled={true} unselectable={"true"} value="">Scegli la tua professione
                        </option>
                        <option className="p-2" value="Impresa edile">Impresa edile</option>
                        <option className="p-2" value="Idraulico">Idraulico</option>
                        <option className="p-2" value="Elettricista">Elettricista</option>
                        <option className="p-2" value="Pittore/Cartongessista">Pittore/Cartongessista</option>
                        <option className="p-2" value="Falegname/Serramentista">Falegname/Serramentista</option>
                        <option className="p-2" value="Posatore/Piastrellista">Posatore/Piastrellista</option>
                        <option className="p-2" value="Giardiniere">Giardiniere</option>
                        <option className="p-2" value="Altro">Altro</option>
                    </select>
                </div>
                <Row className="gap-4 mb-4 flex-col md:flex-row">
                    <Input label="Password"
                           type="password"
                           name="password"
                           required
                           placeholder="min 8 caratteri"/>
                    <Input label="Conferma Password"
                           type="password"
                           required
                           name="confirmPassword"
                           placeholder="min 8 caratteri"/>
                </Row>

                <CheckTermsAndCondition value={checkedTerms} onChange={setCheckedTerms}/>
                {error &&
                <div className="font-bold text-red-600">{error}</div>}
            </div>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

            <Button disabled={!checkedTerms} type="submit" className="mt-4 w-full">Registrati</Button>
        </form>
    );
};

export default Form;